var _objectWithoutProperties = require("/node_modules/@babel/runtime/helpers/objectWithoutProperties");

var _slicedToArray = require("/node_modules/@babel/runtime/helpers/slicedToArray");

var _taggedTemplateLiteral = require("/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  min-width: 1px;\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  display: inline-flex;\n  align-items: center;\n  border-radius: ", ";\n  overflow: hidden;\n  width: ", ";\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  max-width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  background: inherit;\n  display: flex-root;\n  @media (max-width: 990px) {\n    background-position: center center;\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

(function (global, factory) {
  typeof exports === 'object' && typeof module !== 'undefined' ? factory(exports, require('react'), require('styled-components'), require('prop-types'), require('@rtm-ui/layout')) : typeof define === 'function' && define.amd ? define(['exports', 'react', 'styled-components', 'prop-types', '@rtm-ui/layout'], factory) : (global = global || self, factory(global.img = {}, global.React, global.styled, global.PropTypes, global.RtmUiLayout));
})(this, function (exports, React, styled, PropTypes, layout) {
  'use strict';

  var React__default = 'default' in React ? React['default'] : React;
  var styled__default = 'default' in styled ? styled['default'] : styled;
  PropTypes = PropTypes && Object.prototype.hasOwnProperty.call(PropTypes, 'default') ? PropTypes['default'] : PropTypes;

  function _extends() {
    _extends = Object.assign || function (target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];

        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }

      return target;
    };

    return _extends.apply(this, arguments);
  }
  /*
  Responsive Image component to be used inside the Home Page
  */


  var Wrapper = styled__default(layout.Box)(_templateObject());

  var useResponsiveWidth = function useResponsiveWidth() {
    var _React$useState = React.useState(window.innerWidth),
        _React$useState2 = _slicedToArray(_React$useState, 2),
        desktopWidth = _React$useState2[0],
        setDesktopWidth = _React$useState2[1];

    var handleImgResize = function handleImgResize() {
      setDesktopWidth(window.innerWidth);
    };

    window.addEventListener('resize', handleImgResize);
    React.useEffect(function () {
      window.addEventListener('resize', handleImgResize);
      return function () {
        return window.removeEventListener('resize', handleImgResize);
      };
    }, []);
    return window.innerWidth;
  };

  var ResponsiveImage = function ResponsiveImage(_ref) {
    var desktopImgView = _ref.desktopImgView,
        tabletImgView = _ref.tabletImgView,
        mobileImgView = _ref.mobileImgView,
        expandedWidth = _ref.expandedWidth,
        title = _ref.title;
    var theme = React__default.useContext(styled.ThemeContext);
    var minWidth = theme.width[0];
    var midWidth = theme.width[1];
    var imageUrl = '';
    var currentWidth = useResponsiveWidth();
    if (currentWidth <= minWidth) imageUrl = mobileImgView;else if (currentWidth > minWidth && currentWidth <= midWidth) imageUrl = tabletImgView ? tabletImgView : desktopImgView;else imageUrl = desktopImgView;
    return (
      /*#__PURE__*/
      React__default.createElement(Wrapper, null,
      /*#__PURE__*/
      React__default.createElement(Img, {
        expandedWidth: expandedWidth,
        src: imageUrl,
        alt: title || imageUrl,
        title: title || imageUrl
      }))
    );
  };

  ResponsiveImage.propTypes = {
    desktopImgView: PropTypes.string.isRequired,
    tabletImgView: PropTypes.string.isRequired,
    mobileImgView: PropTypes.string.isRequired
  };
  var Wrapper$1 = styled__default(layout.Box)(_templateObject2());

  var borderRadius = function borderRadius(props) {
    return {
      circle: '50%',
      rounded: props.theme.borderRadius
    };
  };

  var ImgWrapper = styled__default(layout.Box)(_templateObject3(), function (props) {
    return borderRadius(props)[props.shape] || '0';
  }, function (props) {
    return props.expandedWidth ? '100%' : '';
  });
  var BaseImg = styled__default.img(_templateObject4());

  var Img = function Img(_ref2) {
    var src = _ref2.src,
        alt = _ref2.alt,
        title = _ref2.title,
        shape = _ref2.shape,
        height = _ref2.height,
        width = _ref2.width,
        boxProps = _objectWithoutProperties(_ref2, ["src", "alt", "title", "shape", "height", "width"]);

    return (
      /*#__PURE__*/
      React__default.createElement(Wrapper$1, null,
      /*#__PURE__*/
      React__default.createElement(ImgWrapper, _extends({
        "data-testid": "testImageWrapper"
      }, boxProps, {
        shape: shape
      }),
      /*#__PURE__*/
      React__default.createElement(BaseImg, {
        height: height,
        title: title,
        width: width,
        src: src,
        alt: alt
      })))
    );
  };

  Img.propTypes = {
    src: PropTypes.string.isRequired,
    alt: PropTypes.string.isRequired,
    shape: PropTypes.oneOf(['circle', 'rounded']),
    width: PropTypes.number,
    height: PropTypes.number
  };
  exports.Img = Img;
  exports.ResponsiveImage = ResponsiveImage;
  Object.defineProperty(exports, '__esModule', {
    value: true
  });
});